import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useUser } from '../context/UserContext';
import { IoPeople, IoCopy, IoCheckmark, IoLogoWhatsapp, IoLogoTwitter } from 'react-icons/io5';
import './InviteFriend.css';

export default function InviteFriend() {
  const { user } = useUser();
  const [copied, setCopied] = useState(false);

  const inviteUrl = `https://plumly.fr/?ref=${user.id}`;
  const inviteText = `Hey ! Viens découvrir Plumly, le Tinder des livres 🪶📖 Rejoins-moi : ${inviteUrl}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(inviteUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="invite-card">
      <div className="invite-header">
        <IoPeople className="invite-icon" />
        <div>
          <h3 className="invite-title">Invite tes amis !</h3>
          <p className="invite-subtitle">Partage Plumly avec tes amis lecteurs</p>
        </div>
      </div>

      <div className="invite-link-row">
        <input className="invite-url" value={inviteUrl} readOnly />
        <motion.button
          className="invite-copy"
          onClick={handleCopy}
          whileTap={{ scale: 0.9 }}
        >
          {copied ? <IoCheckmark /> : <IoCopy />}
        </motion.button>
      </div>

      <div className="invite-share-row">
        <motion.a
          className="invite-share-btn invite-whatsapp"
          href={`https://wa.me/?text=${encodeURIComponent(inviteText)}`}
          target="_blank"
          rel="noopener noreferrer"
          whileTap={{ scale: 0.95 }}
        >
          <IoLogoWhatsapp /> WhatsApp
        </motion.a>
        <motion.a
          className="invite-share-btn invite-twitter"
          href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(inviteText)}`}
          target="_blank"
          rel="noopener noreferrer"
          whileTap={{ scale: 0.95 }}
        >
          <IoLogoTwitter /> Twitter
        </motion.a>
      </div>
    </div>
  );
}